export const LEGACY_CHECKOUT_URL = `${process.env.COSMOS_URL}/signup?referrer=subscribe-app`
export const OAUTH_REDIRECT_URL = `${process.env.NEXT_PUBLIC_SUBSCRIBE_URL}/oauth`
export const LEGACY_SUBSCRIPTIONS_URL = `${process.env.COSMOS_URL}/subscriptions`

if (!process.env.COSMOS_URL) {
  throw new Error('Error reading env variable, COSMOS_URL is required')
}
if (!process.env.NEXT_PUBLIC_SUBSCRIBE_URL) {
  throw new Error('Error reading env variable, NEXT_PUBLIC_SUBSCRIBE_URL is required')
}
